import { jsx as _jsx } from "react/jsx-runtime";
import { Tabs as ChakraTabs } from '@chakra-ui/react';
/**
 * Provides context and logic for all tabs components.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/tabs
 * @see WAI-ARIA https://www.w3.org/WAI/ARIA/apg/patterns/tabpanel/
 */
export function Tabs({ children, ...props }) {
    return (_jsx(ChakraTabs, { variant: "default" // Always custom theme variant "default"
        , size: { base: 'sm', md: 'md' }, ...props, children: children }));
}
//# sourceMappingURL=tabs.js.map